export var INITIALIZE_I18N = 'INITIALIZE_I18N';
export var SET_I18N_READY = 'SET_I18N_READY';
export var initializeI18n = function () { return ({
    type: INITIALIZE_I18N
}); };
export var setI18nReady = function () { return ({
    type: SET_I18N_READY
}); };
